"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var constants_1 = require("./constants");
var Tags_styles_1 = require("./Tags.styles");
var Tag = function (_a) {
    var _b = _a.border, border = _b === void 0 ? false : _b, text = _a.text, _c = _a.bigTag, bigTag = _c === void 0 ? false : _c, _d = _a.blueText, blueText = _d === void 0 ? false : _d, tag = _a.tag, props = __rest(_a, ["border", "text", "bigTag", "blueText", "tag"]);
    return (react_1.default.createElement(Tags_styles_1.TagWrapper, __assign({ className: (0, classnames_1.default)(constants_1.tagColorMap[tag], blueText ? 'text-blue-6' : 'text-white', { '!h-24 !px-16 !py-8 !text-sm leading-6': bigTag }, { 'border border-grey-3': border }) }, props), text));
};
exports.default = Tag;
//# sourceMappingURL=Tag.js.map